export const OVERPAY_RETURN_ROUTE = 'zwrot-nadplaty-za-karte-do-tachografu';
export const OVERPAY_RETURN_FORM_ROUTE = 'formularz'
export const OVERPAY_RETURN_CONFIRMATION_ROUTE = 'potwierdzenie'